import { useEffect, useState } from "react";
import { _DocumentFactory, _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _TimeEvent, _TimeEventAccounting } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { ProductionOrderEditor } from "../../ProductionOrder/ProductionOrderEditor";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../editor/AccountEditor";
import { InputDate } from "../../../theme/Input/InputDate";
import { SelectLabourByPorductionOrder } from "./SelectLabourByPorductionOrder";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { PrintJson } from "../../../theme/Component/PrintJson";


export const TimeEvent = () => {

    const TimeEvent = useDataBean(_TimeEvent);
    const single = Singleton.getInstance();
    const CreateTimemov = useDataBean(_TimeEventAccounting);
    const [order, setOrder] = useState<any>(null)
    const [docsvdos, setDocsvdos] = useState<any>([]);
    const [lista, setLista] = useState<any>([]);
    const [msgList, setMsgList] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const _documentos = useDataBean(_DocumentFactory);
    const [docs, setDocs] = useState<any>([]);
    const [modalcontabletime, setModalcontabletime] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalverdoc, setModalverdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalverdocvdos, setModalverdocvdos] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalbylabourminuts, setModalbylabourminuts] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalbyminuts, setModalbyminuts] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalbyquantity, setModalbyquantity] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalbytime, setModalbytime] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    // useEffect(() => {
    //     getLista();
    // }, [])
    useEffect(() => {
        if (modalverdoc.view) {
            verDocumentos();
        }
    }, [modalverdoc.view]);
    const getLista = () => {

        TimeEvent.instance.getTimeEventCatalog(order.IDProductionOrder).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        TimeEvent.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        TimeEvent.deleteItemVoid(TimeEvent.bean.IDTimeEvent).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }

    const OpenByminuts = () => {
        TimeEvent.setBean({});
        setModalbyminuts({ ...modalbyminuts, "name": `Registrar Tiempos en Minutos`, "view": true });
    }
    const OpenByQuantity = () => {
        TimeEvent.setBean({});
        setModalbyquantity({ ...modalbyquantity, "name": `Registrar Tiempos por Cantidades de Producto Final Producido`, "view": true });
    }
    const OpenByTime = () => {
        TimeEvent.setBean({});
        setModalbytime({ ...modalbytime, "name": `Registrar Tiempos por Cantidades de Actividad`, "view": true });
    }
    const OpenBylabourminuts = () => {
        TimeEvent.setBean({});
        setModalbylabourminuts({ ...modalbylabourminuts, "name": `Registrar Tiempos por Minutos de la Actividad`, "view": true });
    }
    // const addTimeEventByProductionTimeInMinutes = () => {

    //     TimeEvent.instance.addTimeEventByProductionTimeInMinutes(order.IDProductionOrder, order.ProductionOrderDate, TimeEvent.bean.TotalLabourTime, TimeEvent.bean.IDProductionEmployee, TimeEvent.bean.workTurnDate, TimeEvent.bean.IDWorkTurn, _single.getAccountID()).then(
    //         (resp: any) => {
    //             if (resp) {
    //                 console.log(resp)
    //                 toast.success('Operación Exitosa')

    //                 setModalbyminuts({ ...modalbyminuts, "name": `Eliminar`, "view": false });
    //                 getLista();
    //             }
    //         }
    //     ).catch(err => {
    //         toast.error(err);
    //     })

    // }
    const addTimeEventByProductionTimeInMinutes = () => {
        const { IDProductionOrder, ProductionOrderDate } = order || {};
        const { workTurnDate, TotalLabourTime, IDProductionEmployee, IDWorkTurn } = TimeEvent.bean;

        if (!IDProductionOrder || !ProductionOrderDate || !workTurnDate) {
            toast.warn('Debe seleccionar una Orden de Producción y una Fecha de Turno.');
            return;
        }

        TimeEvent.instance.addTimeEventByProductionTimeInMinutes(IDProductionOrder, ProductionOrderDate, TotalLabourTime, IDProductionEmployee, workTurnDate, IDWorkTurn, _single.getAccountID())
            .then((resp: any) => {
                if (resp) {
                    toast.success('Operación Exitosa');
                    setModalbyminuts(prev => ({ ...prev, view: false }));
                    getLista();
                }
            })
            .catch(err => {
                toast.error(err);
            });
    };
    // const addTimeEventByProductionQuantity = () => {

    //     TimeEvent.instance.addTimeEventByProductionQuantity(order.IDProductionOrder, order.ProductionOrderDate, TimeEvent.bean.productQuantity, TimeEvent.bean.IDProductionEmployee, TimeEvent.bean.workTurnDate, TimeEvent.bean.IDWorkTurn, _single.getAccountID()).then(
    //         (resp: any) => {
    //             if (resp) {
    //                 console.log(resp)
    //                 toast.success('Operación Exitosa')

    //                 setModalbyquantity({ ...modalbyquantity, "name": `Eliminar`, "view": false });
    //                 getLista();
    //             }
    //         }
    //     ).catch(err => {
    //         toast.error(err);
    //     })

    // }
    const addTimeEventByProductionQuantity = () => {
        const { IDProductionOrder, ProductionOrderDate } = order || {};
        const { productQuantity, IDProductionEmployee, workTurnDate, IDWorkTurn } = TimeEvent.bean;

        if (!IDProductionOrder || !ProductionOrderDate || !productQuantity || !workTurnDate) {
            toast.warn('Debe completar Orden de Producción, Fecha de Orden, Cantidad Producida y Fecha de Turno.');
            return;
        }

        TimeEvent.instance
            .addTimeEventByProductionQuantity(
                IDProductionOrder,
                ProductionOrderDate,
                productQuantity,
                IDProductionEmployee,
                workTurnDate,
                IDWorkTurn,
                _single.getAccountID()
            )
            .then((resp: any) => {
                if (resp) {
                    toast.success('Operación Exitosa');
                    setModalbyquantity(prev => ({ ...prev, view: false }));
                    getLista();
                }
            })
            .catch(err => {
                toast.error(err);
            });
    };
    // const addTimeEventByLabourQuantity = () => {

    //     TimeEvent.instance.addTimeEventByLabourQuantity(order.IDProductionOrder, order.ProductionOrderDate, TimeEvent.bean.IDLabour, TimeEvent.bean.labourQuantity, TimeEvent.bean.IDProductionEmployee, TimeEvent.bean.workTurnDate, TimeEvent.bean.IDWorkTurn, _single.getAccountID()).then(
    //         (resp: any) => {
    //             if (resp) {
    //                 console.log(resp)
    //                 toast.success('Operación Exitosa')

    //                 setModalbytime({ ...modalbytime, "name": `Eliminar`, "view": false });
    //                 getLista();
    //             }
    //         }
    //     ).catch(err => {
    //         toast.error(err);
    //     })

    // }
    const addTimeEventByLabourQuantity = () => {
        const { IDProductionOrder, ProductionOrderDate } = order || {};
        const { IDLabour, labourQuantity, IDProductionEmployee, workTurnDate, IDWorkTurn } = TimeEvent.bean;

        if (!IDProductionOrder || !ProductionOrderDate || !IDLabour || !labourQuantity || !workTurnDate) {
            toast.warn('Debe completar todos los campos requeridos: Orden de Producción, Fecha, Actividad, Cantidad y Fecha de Turno.');
            return;
        }

        TimeEvent.instance
            .addTimeEventByLabourQuantity(
                IDProductionOrder,
                ProductionOrderDate,
                IDLabour,
                labourQuantity,
                IDProductionEmployee,
                workTurnDate,
                IDWorkTurn,
                _single.getAccountID()
            )
            .then((resp: any) => {
                if (resp) {
                    toast.success('Operación Exitosa');
                    setModalbytime(prev => ({ ...prev, view: false }));
                    getLista();
                }
            })
            .catch(err => {
                toast.error(err);
            });
    };

    const addTimeEventByLabourMinutes = () => {
        const { IDProductionOrder, ProductionOrderDate } = order || {};
        const { IDLabour, labourQuantity, IDProductionEmployee, workTurnDate, IDWorkTurn } = TimeEvent.bean;

        if (!IDProductionOrder || !ProductionOrderDate || !IDLabour || !labourQuantity || !workTurnDate) {
            toast.warn('Debe completar todos los campos requeridos: Orden de Producción, Fecha, Actividad, Cantidad y Fecha de Turno.');
            return;
        }

        TimeEvent.instance
            .addTimeEventByLabourMinutes(
                IDProductionOrder,
                ProductionOrderDate,
                IDLabour,
                labourQuantity,
                IDProductionEmployee,
                workTurnDate,
                IDWorkTurn,
                _single.getAccountID()
            )
            .then((resp: any) => {
                if (resp) {
                    toast.success('Operación Exitosa');
                    setModalbylabourminuts(prev => ({ ...prev, view: false }));
                    getLista();
                }
            })
            .catch(err => {
                toast.error(err);
            });
    };
    const verDocumentos = () => {

        if (TimeEvent.bean) {
            _documentos.instance.getPdfAccountantDocument(TimeEvent.bean.IDDocument, null, TimeEvent.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setModalverdoc({ ...modalverdoc, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const createTimeEventAccountingForProductionOrder = () => {
        CreateTimemov.instance.createTimeEventAccountingForProductionOrder(TimeEvent.bean.IDTimeEvent, CreateTimemov.bean.AccountantDate, CreateTimemov.bean.Description, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Contabilizado')
                    setDocsvdos(resp.DocumentURL);
                    setModalcontabletime({ ...modalcontabletime, "view": false });
                    setModalverdocvdos({ ...modalverdocvdos, "view": true });
                    setMsgList(resp.MsgList);

                    // ✅ Mostrar cada mensaje del backend en un toast
                    resp.MsgList?.forEach((msg: string) => {
                        toast.info(msg);
                    });
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    const editaItem = () => {
        //console.log(entailment.bean);
        TimeEvent.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDTimeEvent', visible: true },
        { title: 'ID Labor/Actividad', property: 'IDLabour', visible: true },
        { title: 'Labor/Actividad', property: 'LabourName', visible: true },
        { title: 'Cantidad Producida', property: 'LabourQuantity', visible: true },
        { title: 'Tiempo Actividad', property: 'TimeUnits', visible: true },
        { title: 'Unidades Tiempo', property: 'LabourTimeUnitName', visible: true },
        { title: 'Empleado', property: 'ProductionEmployeeName', visible: true },
        { title: 'Fecha', property: 'WorkTurnDate', visible: true },
    ]

    // const iconButtonsItem = [
    //     { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    // ]
    const listaBotones = () => {
        const botones = [
            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${TimeEvent.bean.Name}`, "view": true }) } },
            { titulo: 'Ver Documento', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalverdoc({ ...modalverdoc, "view": true }) } },
            { titulo: 'Contabilizar Tiempos y Movimientos', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalcontabletime({ ...modalcontabletime, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Tiempos y Movimientos de Ordenes de Producción">
            <div className="row">
                <div className="col-md-6">
                    <ProductionOrderEditor IDOrderProduction={order} returnData={(e) => { setOrder({ ...order, "IDProductionOrder": e.IDProductionOrder, "ProductionOrderDate": e.ProductionOrderDate }); console.log(e) }} />
                    <strong>Seleccione una Orden*</strong>
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={getLista}>Buscar por Orden*</BasicButton>
                </div>
                {order &&
                    <>
                        <div className="col-md-12">
                            <div className="row mt-4">



                                <div className="col-md-4">
                                    <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={OpenByQuantity}>Registrar Tiempos por Cantidades de Producto Final Producido</BasicButton>
                                </div>
                                <div className="col-md-4">
                                    <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={OpenByTime}>Registrar Tiempos por Cantidades de Actividad</BasicButton>
                                </div>
                                <div className="col-md-4">
                                    <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={OpenBylabourminuts}>Registrar Tiempos por Minutos de la Actividad</BasicButton>
                                </div>
                                <div className="col-md-4 mt-4">
                                    <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={OpenByminuts}>Registrar Tiempos en Minutos</BasicButton>
                                </div>

                            </div>
                            <BasicTable body={lista} head={head} rowSet={TimeEvent.setBean} listButtons={listaBotones()} ></BasicTable>
                            <Modal modal={modalbyminuts} updateModal={setModalbyminuts} eventModal={addTimeEventByProductionTimeInMinutes}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Tiempo total en minutos</label>
                                        <input type="text" name="TotalLabourTime" className="form-control" value={TimeEvent.bean.TotalLabourTime} onChange={TimeEvent.handleChange} />

                                    </div>
                                    <div className="col-md-6">
                                        <AccountEditor idAccount={TimeEvent.bean.IDProductionEmployee} label="Empleado" onChange={(e) => { TimeEvent.setBean({ ...TimeEvent.bean, "IDProductionEmployee": e.IDAccount }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <InputDate name="workTurnDate" label="Fecha de Turno" value={TimeEvent.bean.workTurnDate} setDate={(e: any) => { TimeEvent.setBean({ ...TimeEvent.bean, "workTurnDate": e }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Turno</label>
                                        <input type="text" name="IDWorkTurn" className="form-control" value={TimeEvent.bean.IDWorkTurn} onChange={TimeEvent.handleChange} />
                                    </div>

                                </div>
                            </Modal>
                            <Modal modal={modalverdoc} updateModal={setModalverdoc}>
                                <div className="row">

                                    <DocumentViewer
                                        list={docs}
                                        IDDocument={TimeEvent.bean.IDDocument}
                                        Since={TimeEvent.bean.DocumentDate}
                                    />
                                </div>
                            </Modal>

                            <Modal modal={modalcontabletime} updateModal={setModalcontabletime} eventModal={createTimeEventAccountingForProductionOrder} onSubmitLabel="Contabilizar">
                                <div className="row">
                                    <div className="col-md-12">
                                        <InputDate name="AccountantDate" value={CreateTimemov.bean.AccountantDate} label="Fecha de Contabilización" setDate={(e) => { CreateTimemov.setBean({ ...CreateTimemov.bean, "AccountantDate": e }) }} />
                                    </div>
                                    <div className="col-md-12">
                                        <label>Descripción</label>
                                        <textarea name="Description" className="form-control" value={CreateTimemov.bean.Description} onChange={(e) => { CreateTimemov.setBean({ ...CreateTimemov.bean, 'Description': e.target.value }) }} />
                                    </div>
                                </div>
                            </Modal>
                            <Modal modal={modalverdocvdos} updateModal={setModalverdocvdos}>
                                <div className="row">
                                    <PrintJson json={msgList} />
                                    <DocumentViewer
                                        list={docsvdos}
                                    />
                                </div>
                            </Modal>
                            <Modal modal={modalbyquantity} updateModal={setModalbyquantity} eventModal={addTimeEventByProductionQuantity}>
                                <div className="row">

                                    <div className="col-md-6">
                                        <label>Cantidad Producto Terminado</label>
                                        <input type="text" name="productQuantity" className="form-control" value={TimeEvent.bean.productQuantity} onChange={TimeEvent.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <AccountEditor idAccount={TimeEvent.bean.IDProductionEmployee} label="Empleado" onChange={(e) => { TimeEvent.setBean({ ...TimeEvent.bean, "IDProductionEmployee": e.IDAccount }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <InputDate name="workTurnDate" label="Fecha de Turno" value={TimeEvent.bean.workTurnDate} setDate={(e: any) => { TimeEvent.setBean({ ...TimeEvent.bean, "workTurnDate": e }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Turno</label>
                                        <input type="text" name="IDWorkTurn" className="form-control" value={TimeEvent.bean.IDWorkTurn} onChange={TimeEvent.handleChange} />
                                    </div>
                                </div>
                            </Modal>
                            <Modal modal={modalbytime} updateModal={setModalbytime} eventModal={addTimeEventByLabourQuantity}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Labor/Actividad</label>
                                        <SelectLabourByPorductionOrder render={TimeEvent.bean.Name} idProductionOrder={order.IDProductionOrder} productionOrderDate={order.ProductionOrderDate} idSelector={TimeEvent.bean.IDLabour} onChange={(e) => { TimeEvent.setBean({ ...TimeEvent.bean, "IDLabour": e.IDLabour, "Name": e.Name }) }} label=" " returnType="Object" />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Cantidad Producto Actividad</label>
                                        <input type="text" name="labourQuantity" className="form-control" value={TimeEvent.bean.labourQuantity} onChange={TimeEvent.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <AccountEditor idAccount={TimeEvent.bean.IDProductionEmployee} label="Empleado" onChange={(e) => { TimeEvent.setBean({ ...TimeEvent.bean, "IDProductionEmployee": e.IDAccount }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <InputDate name="workTurnDate" label="Fecha de Turno" value={TimeEvent.bean.workTurnDate} setDate={(e: any) => { TimeEvent.setBean({ ...TimeEvent.bean, "workTurnDate": e }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Turno</label>
                                        <input type="text" name="IDWorkTurn" className="form-control" value={TimeEvent.bean.IDWorkTurn} onChange={TimeEvent.handleChange} />
                                    </div>
                                </div>
                            </Modal>
                            <Modal modal={modalbylabourminuts} updateModal={setModalbylabourminuts} eventModal={addTimeEventByLabourMinutes}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Labor/Actividad</label>
                                        <SelectLabourByPorductionOrder render={TimeEvent.bean.Name} idProductionOrder={order.IDProductionOrder} productionOrderDate={order.ProductionOrderDate} idSelector={TimeEvent.bean.IDLabour} onChange={(e) => { TimeEvent.setBean({ ...TimeEvent.bean, "IDLabour": e.IDLabour, "Name": e.Name }) }} label=" " returnType="Object" />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Cantidad Producto Actividad</label>
                                        <input type="text" name="labourQuantity" className="form-control" value={TimeEvent.bean.labourQuantity} onChange={TimeEvent.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <AccountEditor idAccount={TimeEvent.bean.IDProductionEmployee} label="Empleado" onChange={(e) => { TimeEvent.setBean({ ...TimeEvent.bean, "IDProductionEmployee": e.IDAccount }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <InputDate name="workTurnDate" label="Fecha de Turno" value={TimeEvent.bean.workTurnDate} setDate={(e: any) => { TimeEvent.setBean({ ...TimeEvent.bean, "workTurnDate": e }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Turno</label>
                                        <input type="text" name="IDWorkTurn" className="form-control" value={TimeEvent.bean.IDWorkTurn} onChange={TimeEvent.handleChange} />
                                    </div>
                                </div>
                            </Modal>
                            <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                                <strong>Eliminar item {TimeEvent.bean.Name}</strong>
                            </ModalConfirm>
                        </div>
                    </>}

            </div>
        </BasicPage>
    )
}